module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"TopCategories":{"heading":"Vyberte si z nejpopulárnějších kategorií"}},"de":{"TopCategories":{"heading":"Wählen Sie aus den beliebtesten Kategorien"}},"sk":{"TopCategories":{"heading":"Vyberte si z najpopulárnejších kategórií"}}}')
  delete Component.options._Ctor
}
